export interface PaginationProps {
  pages?: number
  current?: number
}

/**
 * The `.ul-pagination` control. Appears on `blog`, `blog-2`, `events` and
 * `donations`; the markup is identical on all four (the differing MD5s were only
 * indentation), so one component with no per-page configuration serves them.
 *
 * The links all point at `#`: paging is not wired to router state yet. Wire them when
 * a listing actually needs more than one page.
 */
export function Pagination({ pages = 3, current = 1 }: PaginationProps) {
  return (
    <div className="ul-pagination">
      <ul>
        <li>
          <a href="#" aria-label="Previous page">
            <i className="flaticon-back" />
          </a>
        </li>
        <li className="pages">
          {Array.from({ length: pages }, (_, i) => i + 1).map((n) => (
            <a key={n} href="#" {...(n === current ? { className: 'active' } : {})}>
              {n}
            </a>
          ))}
        </li>
        <li>
          <a href="#" aria-label="Next page">
            <i className="flaticon-next" />
          </a>
        </li>
      </ul>
    </div>
  )
}
